export default "__VITE_ASSET__c335a02a__"